import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { SwitchComponent } from "./switch.component";

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule.withConfig({callSetDisabledState: 'whenDisabledForLegacyCode'}),
        FormsModule
    ],
    declarations: [
        SwitchComponent
    ],
    exports: [
        SwitchComponent
    ]
})

export class SwitchModule {
}
